import { createSlice } from '@reduxjs/toolkit';
import { fetchPendingJoinRequestsCount } from './thunks';
import { RootState } from '../../../app/store/store';

type FetchStatus = 'idle' | 'loading' | 'succeeded' | 'failed';

interface JoinRequestsState {
  count: number;
  status: FetchStatus;
}

const initialState: JoinRequestsState = {
  count: 0,
  status: 'idle',
};

const joinRequestsSlice = createSlice({
  name: 'joinRequests',
  initialState,
  reducers: {
    resetJoinRequests: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingJoinRequestsCount.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPendingJoinRequestsCount.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.count = action.payload;
      })
      .addCase(fetchPendingJoinRequestsCount.rejected, (state) => {
        state.status = 'failed';
        // На ошибке оставляем последнее известное значение —
        // обнулять, чтобы бейдж пропал из-за временной 5xx, неправильно.
      });
  },
});

export const { resetJoinRequests } = joinRequestsSlice.actions;
export default joinRequestsSlice.reducer;

export const selectJoinRequestsCount = (state: RootState): number =>
  state.joinRequests.count;
